module.exports = __webpack_public_path__ + "static/img/book8.27936b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book8.jpg
// module id = sfr8
// module chunks = 1